import { render } from "./BottomNav.vue?vue&type=template&id=6fd63c76"
import script from "./BottomNav.vue?vue&type=script&lang=js"
export * from "./BottomNav.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fikri/Work/PRiADI/code/priadi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__